import { Controller } from "@hotwired/stimulus";
import React from "react";
import { createRoot } from "react-dom/client";

export default class extends Controller {
  static values = { path: String, props: String };

  connect() {
    this.renderReactComponent();
  }

  async renderReactComponent() {
    try {
      const Component = (await import(`../components/${this.pathValue}`)).default;
      if (!Component) {
        console.log("Component not found in ${this.pathValue}:", this.pathValue);
        throw new Error(`Component not found in ${this.pathValue}`);
      }

      const props = JSON.parse(this.propsValue);

      this.root = createRoot(this.element);
      this.root.render(<Component {...props} />);
    } catch (error) {
      console.error("Error loading React component:", error);
    }
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}

/*
  To call components in views:
  - props = { name: "marco", email: "marco@email.com" }
  div class="react-component" data-controller="react" data-react-path-value="HelloReact.jsx" data-react-props-value="#{props.to_json}"
 */
